// 车型库首页
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import getQuery from '@arsenal/arsenal/modules/getQuery'
import Brand from './brand'
import ConditionsList from './conditions-list'
import { ContextProvider } from './reducer'
import { ISortProps, IConditionsProps, IInfoProps } from './interface'

interface IPictureProps {
  // 过滤条件
  conditions: IConditionsProps[]
  // 排序条件
  sort: ISortProps[]
  // 品牌
  brands: IInfoProps[][]
  // 品牌字母
  letters: string[]
}

function Picture({ conditions, sort, letters, brands }: IPictureProps) {
  const [init, setInit] = useState<any>()
  useEffect(() => {
    if (getQuery('key')) {
      const keys = getQuery('key').split('`') as string[]
      const param = (getQuery('param') || '').split('`') as string[]
      const text = (getQuery('text') || '').split('`') as string[]
      const initProps = keys.reduce((acc: any, curr, index) => {
        if (!curr) {
          return acc
        }
        if (!acc[curr]) {
          acc[curr] = []
        }
        acc[curr].push({
          param: Number(param[index]) || param[index],
          text: text[index],
        })
        return acc
      }, {})
      setInit(initProps)
    } else {
      setInit({})
    }
  }, [])
  return (
    <div>
      <Head>
        <title key="title">汽车图片大全-汽车图片库-懂车帝</title>
        <meta
          key="keywords"
          name="keywords"
          content="懂车帝官网,汽车,汽车网站,汽车报价,汽车报价大全,汽车大全,汽车价格查询,汽车图片,车型库,汽车之家报价,汽车标志"
        />
        <meta
          key="description"
          name="description"
          content="懂车帝提供最全面的汽车车型大全，包括2019最新汽车报价查询、品牌最全车型最全的全国最低价格及本地报价、图片、评测、口碑、经销商、油耗、资讯等信息，看车选车买车就上懂车帝。"
        />
      </Head>
      <ContextProvider initProps={init}>
        <Brand letters={letters} brands={brands} />
        <ConditionsList conditions={conditions} sort={sort} />
      </ContextProvider>
      <style jsx>
        {`
          div {
            width: 1190px;
            margin: 24px auto 0 auto;
          }
        `}
      </style>
    </div>
  )
}

export default Picture
